export default __webpack_public_path__ + "media/zurb/img/playground/signal-blitz-icon-39fba3302604e6e14cd93f779becd42b.svg";